const financeProductsTranslations: Record<string, string> = {
  FIN_PROD_AUS_SUB_LOAN: 'trans__configurator__customise_page_finance_details__loan_type_loan',
  FIN_PROD_AUS_SUB_GFV: 'trans__configurator__customise_page_finance_details__loan_type_gfv',
};

export default financeProductsTranslations;
